import { createFileRoute, Link } from '@tanstack/react-router'
import { GuideArticle, GuideSection } from '~/components/guide/GuideArticle'

export const Route = createFileRoute('/guide/admin-settings/users-roles')({
  component: UsersRoles,
})

function UsersRoles() {
  return (
    <GuideArticle>
      <GuideSection id="users" title="Users">
        <p>
          Admins manage people under{' '}
          <Link to="/admin/users" className="underline underline-offset-2">Admin → Users</Link>:
          invite teammates, set their role, and mark who belongs to the developer
          pool (eligible for assignment and AI implementation work).
        </p>
      </GuideSection>

      <GuideSection id="roles" title="Roles &amp; permissions">
        <p>
          Roles bundle permissions. Permissions are <code>resource:verb</code>{' '}
          pairs (for example <code>items:delete</code>). Resource permissions
          such as <code>users:read</code> gate both the UI and the API; the{' '}
          <code>api:read</code>, <code>mcp:read</code> and <code>guide:read</code>{' '}
          permissions are UI-visibility gates — they show the API reference,
          MCP instructions and guide sections (pages and sidebar links), and
          without them those sections are hidden. <code>admin</code> implies
          every other permission. First Response ships system roles such as{' '}
          <strong>Admin</strong> (full access); manage them under{' '}
          <Link to="/admin/roles" className="underline underline-offset-2">Admin → Roles</Link>.
        </p>
      </GuideSection>

      <GuideSection id="eta-settings" title="ETA settings">
        <p>
          <Link to="/admin/eta-settings" className="underline underline-offset-2">Admin → ETA settings</Link>{' '}
          sets the move threshold, refresh time, GPS age limit and Google calls
          per minute used for board ETAs, and the two switches that turn on the
          Kestrel comparison for the ETA tracker and the board ETAs. It also
          shows Google call counts and lists the board ETAs requested in the last hour. See the{' '}
          <Link to="/guide/eta" className="underline underline-offset-2">ETA guide</Link>{' '}
          for what each setting does.
        </p>
      </GuideSection>

    </GuideArticle>
  )
}
